module.exports = __webpack_public_path__ + "panel-switch.svg?74ef6918804bf2ba3039e96d5bcaf5c6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/panel-switch.svg
// module id = 55
// module chunks = 0